import { createAction, props } from "@ngrx/store";
import { BenefitGroup } from "../../models/benefit-group";

export const findBenefitGroupAct = createAction('findBenefitGroupEffect', props <{ id: number }>());
export const loadBenefitGroupByIdAct = createAction('loadBenefitGroupByIdEffect', props<{ benefitGroup: BenefitGroup }>());

export const resetBenefitGroupAct = createAction('resetBenefitGroupEffect');

export const updateBenefitGroupAct = createAction('updateBenefitGroupEffect', props<{ benefitGroupUpdated: BenefitGroup }>());
export const updateSuccessBenefitGroupAct = createAction('updateSuccessBenefitGroupEffect', props<{ benefitGroupUpdated: BenefitGroup }>());

export const saveBenefitGroupAct = createAction('saveBenefitGroupEffect', props<{ benefitGroupNew: BenefitGroup }>());
export const saveSuccessBenefitGroupAct = createAction('saveSuccessBenefitGroupEffect', props<{ benefitGroupNew: BenefitGroup }>());

export const setViolationsBenefitGroupAct = createAction('setViolationsBenefitGroupEffect', props<{ benefitGroupForm: BenefitGroup, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
